<div class="custom-drop-down">
  <p *ngIf="label">
    {{ label }}
    <span
      *ngIf="control.hasValidator(requiredValidator)"
      class="required-asterisk"
      >*</span
    >
  </p>
  <p-dropdown
    [ngClass]="{
      invalid: control.invalid && showError,
      disabled: control.disabled
    }"
    (onChange)="optionChanged($event)"
    [autofocusFilter]="false"
    [filter]="filter"
    [filterBy]="filterBy"
    [formControl]="control"
    [optionLabel]="isObjectArray() ? optionLabel : undefined"
    [optionValue]="isObjectArray() ? optionValue : undefined"
    [options]="options"
    [overlayOptions]="getOverlayOptions()"
    [placeholder]="placeholder"
    [scrollHeight]="deviceWidth > 380 ? '200px' : '85px'"
    [showClear]="showClear"
    [emptyMessage]="emptyFilterMessage | translate"
    [virtualScroll]="virtualScroll"
    [virtualScrollItemSize]="virtualScrollItemSize"
  >
  <ng-template pTemplate="selectedItem" let-selected>
    <div *ngIf="selected">
      <span *ngIf="isObjectArray()">{{ selected[optionLabel] }}</span>
      <span *ngIf="!isObjectArray()">{{ selected }}</span>
    </div>
  </ng-template>

  <ng-template pTemplate="item" let-item>
    <div>
      <span *ngIf="isObjectArray()">{{ item[optionLabel] }}</span>
      <span *ngIf="!isObjectArray()">{{ item }}</span>
    </div>
  </ng-template>
  </p-dropdown>
  <span *ngIf="control.invalid && showError" class="error-message">{{
    "enterValueError" | translate
  }}</span>
</div>
